export default __webpack_public_path__ + "2805e4c0bc338b285abaae4d0aaee4b6.jpg";